import {
  INCIDENCES_REQUEST, INCIDENCES_SUCCESS, INCIDENCES_FAILURE,
  INCIDENCE_REQUEST, INCIDENCE_SUCCESS, INCIDENCE_FAILURE,
  INCIDENCE_ADD_REQUEST, INCIDENCE_ADD_SUCCESS, INCIDENCE_ADD_FAILURE,
  INCIDENCE_UPDATE_REQUEST, INCIDENCE_UPDATE_SUCCESS, INCIDENCE_UPDATE_FAILURE,
  INCIDENCE_REVIEW_REQUEST, INCIDENCE_REVIEW_SUCCESS, INCIDENCE_REVIEW_FAILURE,
  INCIDENCE_REPAIR_REQUEST, INCIDENCE_REPAIR_SUCCESS, INCIDENCE_REPAIR_FAILURE,
  INCIDENCE_RESOLVE_REQUEST, INCIDENCE_RESOLVE_SUCCESS, INCIDENCE_RESOLVE_FAILURE,
  INCIDENCE_RESET,
  INCIDENCES_OPEN_COUNT_REQUEST, INCIDENCES_OPEN_COUNT_SUCCESS, INCIDENCES_OPEN_COUNT_FAILURE
} from '../actions/incidences'

const INITIAL_STATE = {
  incidences: null, incidence: null, error: null, loading: false, incidenceNeedRefresh: false, openIncidencesCount: 0
}

const incidencesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case INCIDENCES_REQUEST:
        return {
          ...state,
          error: null, loading: true, incidenceNeedRefresh: false
        }
      case INCIDENCES_SUCCESS:
        return {
          ...state,
          incidences: action.response, error: null, loading: false, incidenceNeedRefresh: false
        }
      case INCIDENCES_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case INCIDENCE_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case INCIDENCE_SUCCESS:
        return {
          ...state,
          incidence: action.response, error: null, loading: false, incidenceNeedRefresh: false
        }
      case INCIDENCE_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case INCIDENCE_ADD_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case INCIDENCE_ADD_SUCCESS:
        return {
          ...state,
          incidence: action.response, error: null, loading: false
        }
      case INCIDENCE_ADD_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case INCIDENCE_UPDATE_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case INCIDENCE_UPDATE_SUCCESS:
        return {
          ...state,
          incidence: action.response, error: null, loading: false, incidenceNeedRefresh: true
        }
      case INCIDENCE_UPDATE_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      // Review incidence
      case INCIDENCE_REVIEW_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case INCIDENCE_REVIEW_SUCCESS:
        return {
          ...state,
          incidence: action.response, error: null, loading: false, incidenceNeedRefresh: true
        }
      case INCIDENCE_REVIEW_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      // Repair incidence
      case INCIDENCE_REPAIR_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case INCIDENCE_REPAIR_SUCCESS:
        return {
          ...state,
          incidence: action.response, error: null, loading: false, incidenceNeedRefresh: true
        }
      case INCIDENCE_REPAIR_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      // Resolve incidence
      case INCIDENCE_RESOLVE_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case INCIDENCE_RESOLVE_SUCCESS:
        return {
          ...state,
          incidence: action.response, error: null, loading: false, incidenceNeedRefresh: true
        }
      case INCIDENCE_RESOLVE_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case INCIDENCE_RESET:
        return {
          ...state,
          incidence: null, error: null, loading: false
        }
      case INCIDENCES_OPEN_COUNT_REQUEST:
        return {
          ...state
        }
      case INCIDENCES_OPEN_COUNT_SUCCESS:
        return {
          ...state,
          openIncidencesCount: action.response.count
        }
      case INCIDENCES_OPEN_COUNT_FAILURE:
        return {
          ...state
        }
      default:
        return state
    }
  }

export default incidencesReducer

